import React from 'react'
import PropTypes from 'prop-types'

import Campaign from './Campaign'
import CampaignComparable from './CampaignComparable'
import ImageLibrary from './ImageLibrary'
import User from './User'

const components = {
  Campaign,
  CampaignComparable,
  ImageLibrary,
  User,
}

const LibrarySelector = (props) => {
  const { imageSelectPayload, imageSelectPayload: { selectedEntityType } } = props

  const Component = components[selectedEntityType]
  if (!Component){
    return null
  }

  return <Component imageSelectPayload={imageSelectPayload} />
}

LibrarySelector.propTypes = {
  imageSelectPayload: PropTypes.shape({
    selectedEntityType: PropTypes.string.isRequired,
  }).isRequired,
}

export default LibrarySelector
